import { render, staticRenderFns } from "./recipe-listing-card.vue?vue&type=template&id=a0f7571a&"
import script from "./recipe-listing-card.vue?vue&type=script&lang=js&"
export * from "./recipe-listing-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports